module.exports = __webpack_public_path__ + "static/media/gitbook_icon_g.ceb5a145.svg";